import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { SiteCard } from './ProductShowcase'

function Slaughterhouse() {
  const navigate = useNavigate()

  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='page-title-block'>
          <Typography className='page-title'>Refrigeration for Chicken Slaughterhouse</Typography>
          <Typography className='page-subtitle'>
            Blast refrigeration for meat and poultry processing.
          </Typography>
        </div>

        <div className='pp-site-grid'>
          <SiteCard
            image='/machines-images/Slaughterhouse/nepal.jpg'
            title='Nepal'
            caption='20 tons / day blast refrigeration capacity'
            onOpen={() => navigate('/product/slaughterhouse/nepal')}
          />
        </div>
      </main>

      <Footer />
    </>
  )
}

export default Slaughterhouse
